import { render, staticRenderFns } from "./Cartelera.vue?vue&type=template&id=96541782"
import script from "./Cartelera.vue?vue&type=script&lang=js"
export * from "./Cartelera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports